export class UIAdElements {
    readonly containerLobbyLeft: HTMLDivElement
    readonly containerLobbyRight: HTMLDivElement
    readonly containerLobby300x250: HTMLDivElement
    readonly lobbyAbVLI300x250: HTMLDivElement
    readonly containerGameLeft: HTMLDivElement
    readonly containerGameRight: HTMLDivElement
    readonly containerGameBottom: HTMLDivElement
    readonly containerGameBottomSmall: HTMLDivElement

    readonly removeAdInGameLeft: HTMLLinkElement
    readonly removeAdInGameRight: HTMLLinkElement

    constructor() {
        this.containerLobbyLeft = document.getElementById('lobby_ad_left') as HTMLDivElement
        this.containerLobbyRight = document.getElementById('lobby_ad_right') as HTMLDivElement
        this.containerLobby300x250 = document.getElementById('homepage_ab_300x250_container') as HTMLDivElement
        this.lobbyAbVLI300x250 = document.getElementById('homepage_ab_vli_300x250') as HTMLDivElement
        this.containerGameLeft = document.getElementById('in_game_ab_left') as HTMLDivElement
        this.containerGameRight = document.getElementById('in_game_ab_right') as HTMLDivElement
        this.containerGameBottom = document.getElementById('in_game_ab_bottom') as HTMLDivElement
        this.containerGameBottomSmall = document.getElementById('in_game_ab_bottom_small') as HTMLDivElement

        this.removeAdInGameLeft = document.getElementById('remove_ad_in_game_left') as HTMLLinkElement
        this.removeAdInGameRight = document.getElementById('remove_ad_in_game_right') as HTMLLinkElement
    }
}
